import { UseFormReturn } from 'react-hook-form'
import { InputFormValues } from '@/modules/CombinedLogs/types'
import { Input } from '@/ui/Input'
import { KeyboardEvent } from 'react'
import styles from '../../../../CombinedLogs.module.scss'

export const TableFormTimeInput = ({ form }: { form: UseFormReturn<InputFormValues> }) => {
    const handleTimeKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', ':']
        // Allow numbers 0-9
        if (/^\d$/.test(e.key)) {
            return
        }
        if (allowedKeys.includes(e.key)) {
            return
        }
        e.preventDefault()
    }

    const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        if (value.length > 2 && !value.includes(':')) {
            form.setValue('timeStamp', `${value.slice(0, 2) + ':' + value.slice(2)}`, { shouldValidate: true })
        }
    }

    return (
        <Input
            {...form.register('timeStamp', {
                onChange: handleTimeChange,
            })}
            variant="table"
            type="text"
            transparent
            fullWidth
            className={styles.greyInput}
            placeholder={'Time'}
            pattern="[0-9]{2}:[0-9]{2}"
            maxLength={5}
            onKeyDown={handleTimeKeyDown}
        />
    )
}
